import { useContext } from "react";
import { Route, Routes } from "react-router-dom";

import { AppRulesContext } from "../App";
import GuardedRoute from "../components/GuardedRoute";
import PageNotFound from "../pages/PageNotFound";
import ITRFiling from "../pages/itr-filing/ITRFiling";
import ITRFilingList from "../pages/itr-filing/ITRFilingList";
import PlanCheckout from "../pages/plans/PlanCheckout";
import PricingPlans from "../pages/plans/PricingPlans";
import PublicPricingPlans from "../pages/public-pages/PublicPricingPlans";

const ITRFilingNavigator = () => {
  const { rulesSvc } = useContext(AppRulesContext);

  return (
    <Routes>
      {/* for Listing ITR filings */}
      <Route index element={<ITRFilingList />} />
      {/* for Update existing ITR filing */}
      {/* visible to all, for admin (without edit) */}
      <Route
        path="/:filingUUID"
        element={<GuardedRoute rules={rulesSvc.updateAndSingleEFiling} element={<ITRFiling />} />}
      />
      {/* for purchasing a plan for ITR filing */}
      <Route
        path="/:filingUUID/:planType/plans"
        element={
          <GuardedRoute rules={rulesSvc.updateAndSingleEFiling} element={<PricingPlans />} />
        }
      />

      {/* for checkout a plan for ITR filing */}
      <Route
        path="/:filingUUID/:planType/plan-checkout"
        element={
          <GuardedRoute rules={rulesSvc.updateAndSingleEFiling} element={<PlanCheckout />} />
        }
      />

      {/* for public purchasing a plan for ITR filing */}
      <Route
        path="/:filingUUID/:planType/publicPlans"
        element={
          <GuardedRoute rules={rulesSvc.updateAndSingleEFiling} element={<PublicPricingPlans />} />
        }
      />
      {/* for Add new ITR filing */}
      <Route
        path="/0"
        element={<GuardedRoute rules={rulesSvc.createEFiling} element={<ITRFiling />} />}
      />
      {/* for select income source before ITR filing */}
      {/* <Route
        path="/income-sources"
        element={<GuardedRoute rules={rulesSvc.createEFiling} element={<ITRIncomeSources />} />}
      /> */}

      {/* URL Not Found */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default ITRFilingNavigator;
